// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uDtZ","footer":"styles_footer__1VicG"};